import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CssBaseline, GlobalStyles } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#245b59',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f2a93b',
      contrastText: '#173434',
    },
    background: {
      default: '#f6f8f5',
      paper: '#ffffff',
    },
    text: {
      primary: '#183b3b',
      secondary: '#58706e',
    },
  },
  typography: {
    fontFamily: 'Inter, "Manrope", system-ui, sans-serif',
    h1: {
      fontFamily: '"Bricolage Grotesque", "Manrope", system-ui, sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontFamily: '"Bricolage Grotesque", "Manrope", system-ui, sans-serif',
      fontWeight: 700,
      letterSpacing: '-0.02em',
    },
    h3: {
      fontFamily: '"Bricolage Grotesque", "Manrope", system-ui, sans-serif',
      fontWeight: 700,
    },
    h4: {
      fontFamily: '"Bricolage Grotesque", "Manrope", system-ui, sans-serif',
      fontWeight: 700,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          body: {
            backgroundImage:
              'radial-gradient(circle at 100% 0%, rgba(242,169,59,.17), transparent 27rem), radial-gradient(circle at 0% 30%, rgba(59,124,111,.10), transparent 28rem), #f6f8f5',
            minHeight: '100vh',
          },
          '#root': {
            minHeight: '100vh',
          },
        }}
      />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
